import { render, staticRenderFns } from "./FjWithdrawal.vue?vue&type=template&id=777603dc&scoped=true&"
var script = {}
import style0 from "./FjWithdrawal.vue?vue&type=style&index=0&id=777603dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777603dc",
  null
  
)

export default component.exports